var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "22",
        height: "17",
        viewBox: "0 0 22 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M21.8682 1.29761C21.8682 1.06949 21.7643 0.853762 21.586 0.711448C21.4077 0.569134 21.1744 0.515705 20.9519 0.56627L0.951922 5.11248C0.610468 5.19009 0.368164 5.49366 0.368164 5.84382V8.73687C0.368164 9.06037 0.575582 9.34741 0.882722 9.44896L6.17256 11.198C5.74434 13.062 6.83835 14.9601 8.69772 15.5062C10.477 16.0287 12.3362 15.1307 13.0606 13.4754L20.8827 16.0617C21.1113 16.1373 21.3623 16.0985 21.5574 15.9575C21.7526 15.8165 21.8682 15.5904 21.8682 15.3496V1.29761ZM11.6255 13.0009L7.60752 11.6724C7.43848 12.7226 8.07304 13.7594 9.12037 14.0669C10.12 14.3605 11.1626 13.8919 11.6255 13.0009ZM1.86816 8.19492V6.44247L20.3682 2.23723V14.3117L1.86816 8.19492Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }